import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { VitrinenNavbarComponent } from './vitrine-navbar/vitrine-navbar.component';
import { VitrinenFooterComponent } from './vitrine-footer/vitrine-footer.component';

@NgModule({
  declarations: [VitrinenNavbarComponent, VitrinenFooterComponent],
  imports: [CommonModule, RouterModule],
  exports: [VitrinenNavbarComponent, VitrinenFooterComponent],
})
export class VitrinenSharedModule {}
